import React from "react";
import { useTranslation } from "react-i18next";

import {
  useRetrieveCurrentPlanzone,
  useZoneRetrieval,
  useZonesRetrieval,
} from "@planzone/view-models";
import { UseCases } from "@planzone/core";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { Display } from "@common/display";
import { Layout } from "@common/layout";
import { Zone } from "@scenes/zone";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { CloseIcon } from "./closeIcon";
import { Header } from "./header";
import { ReportsPage } from "./reportsPage";
import { GanttPage } from "./ganttPage";
import { ProjectsPage } from "./projectsPage";
import { WbsPage } from "./wbsPage";
import { WorkloadsPage } from "./workLoadsPage";
import { ZonesPage as ZonesSubPage } from "./zonesPage";
import styles from "./styles.scss";

function ZonesPage(props: Props) {
  const { t } = useTranslation();
  const { zone: z } = useZoneRetrieval();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { zones } = useZonesRetrieval(planzone);
  const { pushView } = useModal();
  const zone = zones.find(({ uuid }) => uuid === props.zoneId);

  return (
    <WorkspaceContext type="planzone">
      <div className={styles.zonesPage}>
        <Layout>
          <div className={styles.content}>
            <Header />
            <div className={styles.main}>
              {props.slug === "zones" ? (
                <ZonesSubPage {...props} />
              ) : props.slug === "projects" ? (
                <ProjectsPage {...props} />
              ) : props.slug === "gantt" ? (
                <GanttPage />
              ) : props.slug === "reports" ? (
                <ReportsPage />
              ) : props.slug === "lists" ? (
                <WbsPage />
              ) : props.slug === "workloads" ? (
                <WorkloadsPage />
              ) : (
                <ZonesSubPage {...props} />
              )}
            </div>
          </div>
        </Layout>
        {zone && (
          <div className={styles.zone}>
            <Display closeDisplay={props.getAllZone}>
              <div className={styles.zoneHeader}>
                <div className={styles.zoneHeading} onClick={props.getAllZone}>
                  <CloseIcon className={styles.icon} />
                  <h3 className={styles.zoneTitle}>{t("zone.close")}</h3>
                </div>
              </div>
              <div className={styles.zoneMain}>
                <Zone
                  zone={{ ...z, ...zone }}
                  removeZone={(zone) =>
                    pushView({ key: UseCases.removeZone, data: zone })
                  }
                  transferProjects={(zone) =>
                    pushView({
                      key: UseCases.transferProjects,
                      data: { zone, projects: [] },
                    })
                  }
                  editZone={(zone) =>
                    pushView({ key: UseCases.editZone, data: zone })
                  }
                />
              </div>
            </Display>
          </div>
        )}
      </div>
    </WorkspaceContext>
  );
}

export { ZonesPage };
